export default "__VITE_ASSET__9f4a0d6c__"